import React, { Suspense, useContext } from 'react';
import { bool, string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { dynamicRecsDataModel } from '../dataModel';

const DynamicRecsWrapper = (props) => {
  const { federatedFeatureSwitch, anchor, anchorId } = props;
  const experienceContext = useContext(ExperienceContext);
  const { isServer } = experienceContext;
  let EvaluatedRecs;
  if (federatedFeatureSwitch) {
    EvaluatedRecs = React.lazy(() => import(/* webpackChunkName: "DynamicRecs" */'./DynamicRecs'));
  } else {
    EvaluatedRecs = React.lazy(() => import(/* webpackChunkName: "DynamicProductRecs" */'./DynamicProductRecs'));
  }
  if (!isServer) {
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <Suspense fallback={(<div />)}>
        <EvaluatedRecs {...props} anchor={anchor || anchorId} />
      </Suspense>
    );
  } return null;
};

DynamicRecsWrapper.dataModel = dynamicRecsDataModel;

DynamicRecsWrapper.propTypes = {
  federatedFeatureSwitch: bool,
  anchorId: string.isRequired,
  schemaName: string.isRequired,
  anchor: string
};

DynamicRecsWrapper.defaultProps = {
  anchor: null,
  federatedFeatureSwitch: true
};

export { DynamicRecsWrapper };
